import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';

import { ConceptoIndexComponent } from './ConceptoIndex.component';
import { ConceptoEditComponent } from './ConceptoEdit.component';
import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';
import { MatDialogModule } from '@angular/material';


const routes = [
    {
        path     : 'Concepto',
        component: ConceptoIndexComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Concepto',
          nombreFormulario : 'Conceptos'
        } 
    },
    {
        path     : 'Concepto/i/:cnumcont/:cprefijo/:edi',
        component: ConceptoIndexComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Concepto',
          nombreFormulario : 'Conceptos'
        } 
    },
    {
        path     : 'Concepto/:cnumcont/:ccodcon',
        component: ConceptoIndexComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Concepto',
          nombreFormulario : 'Concepto Filtro Contrato - Prefijo'
        } 
    },
    {
        path     : 'Concepto/:editar/:cnumcont/:ccodcon/:ciddoc',
        component: ConceptoEditComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Concepto',
          nombreFormulario : 'Editar Concepto'
        } 
    },
    {
        path     : 'Concepto/:editar/:cnumcont/:ciddoc',
        component: ConceptoEditComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Concepto',
          nombreFormulario : 'Crear Concepto'
        } 
    }
];

@NgModule({
    declarations: [
        ConceptoIndexComponent,
        ConceptoEditComponent
    ],
    imports     : [
        SharedModule,
        MatDialogModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        ConceptoIndexComponent,
        ConceptoEditComponent
    ]
})

export class ConceptoModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/CrearConcepto/Concepto.module.ts